import {
  CheckCircle2,
  FileText,
} from "lucide-react";
import type {
  useOffersWorkspace,
} from "./useOffersWorkspace";

export function OfferComparison({ model }: { model: ReturnType<typeof useOffersWorkspace>; }) {
  const {
    user,
    evaluation,
    systemOffer,
    alternativeOffers,
    singleOffer,
    excludedOffers,
  } = model;
  return (<>
    {evaluation && user.role !== "SATIN_ALMA" ? (
      <section className="offer-comparison">
        <div className="section-heading compact">
          <div>
            <span className="section-kicker">Otomatik karar desteği</span>
            <h2>Sistem Önerisi · Sürüm {evaluation.version}</h2>
          </div>
        </div>
        {systemOffer ? (
          <article className="system-offer-hero">
            <div className="system-offer-title">
              <span>
                <CheckCircle2 size={16} /> Önerilen teklif
              </span>
              <h3>{systemOffer.supplier}</h3>
              <p>{systemOffer.offerNo}</p>
            </div>
            <strong className="system-offer-score">
              {systemOffer.totalScore}
              <small>/100</small>
            </strong>
            <div className="system-offer-metrics">
              <div>
                <small>Toplam maliyet</small>
                <strong>
                  {systemOffer.comparableTotal?.toLocaleString("tr-TR")}{" "}
                  {evaluation.comparisonCurrency}
                </strong>
              </div>
              <div>
                <small>Teslimat</small>
                <strong>{systemOffer.deliveryDays} gün</strong>
              </div>
              <div>
                <small>Ödeme vadesi</small>
                <strong>{systemOffer.paymentDays} gün</strong>
              </div>
            </div>
            <p className="system-offer-note">
              Fiyat %{evaluation.weights.amount}, teslimat %
              {evaluation.weights.delivery} ve ödeme %
              {evaluation.weights.payment} ağırlıklarıyla ilk sırada.
              {evaluation.categoryProfile
                ? ` ${evaluation.categoryProfile.name} profili uygulandı${systemOffer.performanceScore === null || systemOffer.performanceScore === undefined ? "; geçmiş performans veri yetersizliği nedeniyle puana katılmadı." : `; geçmiş performans %${evaluation.categoryProfile.performanceWeight} etkili.`}`
                : ""}
            </p>
            {evaluation.confidence || evaluation.sensitivity ? (
              <div className="evaluation-assurance" role="status">
                {evaluation.confidence ? (
                  <span>
                    Veri güveni:{" "}
                    <strong>%{evaluation.confidence.score}</strong>
                  </span>
                ) : null}
                {evaluation.sensitivity ? (
                  <span>
                    Karar sağlamlığı:{" "}
                    {evaluation.sensitivity.stable ? "Kararlı" : "Hassas"}
                  </span>
                ) : null}
                {evaluation.sensitivity ? (
                  <small>{evaluation.sensitivity.message}</small>
                ) : null}
              </div>
            ) : null}
          </article>
        ) : singleOffer ? (
          <article className="system-offer-hero single-source-offer">
            <div className="system-offer-title">
              <span>
                <FileText size={16} /> Tek geçerli teklif
              </span>
              <h3>{singleOffer.supplier}</h3>
              <p>{singleOffer.offerNo}</p>
            </div>
            <div className="system-offer-metrics">
              <div>
                <small>Toplam maliyet</small>
                <strong>
                  {singleOffer.comparableTotal?.toLocaleString("tr-TR")}{" "}
                  {evaluation.comparisonCurrency}
                </strong>
              </div>
              <div>
                <small>Teslimat</small>
                <strong>{singleOffer.deliveryDays} gün</strong>
              </div>
              <div>
                <small>Ödeme vadesi</small>
                <strong>{singleOffer.paymentDays} gün</strong>
              </div>
            </div>
            <p className="system-offer-note">
              Karşılaştırılacak ikinci teklif bulunmadığı için sistem puan
              veya öneri üretmedi. Satın Alma gerekçeli tek kaynak kararı
              verebilir.
            </p>
          </article>
        ) : (
          <div className="evaluation-empty">
            <strong>Henüz sistem önerisi üretilemedi.</strong>
            <span>{evaluation.message}</span>
          </div>
        )}
        {alternativeOffers.length ? (
          <div className="alternative-offers">
            <div className="compact-block-title">
              <strong>Diğer geçerli teklifler</strong>
              <span>{alternativeOffers.length} teklif</span>
            </div>
            {alternativeOffers.map((offer) => (
              <div className="alternative-offer-row" key={offer.id}>
                <span className="alternative-rank">{offer.rank}</span>
                <div>
                  <strong>{offer.supplier}</strong>
                  <small>{offer.offerNo}</small>
                </div>
                <strong>
                  {offer.comparableTotal?.toLocaleString("tr-TR")}{" "}
                  {evaluation.comparisonCurrency}
                </strong>
                <span>{offer.deliveryDays} gün teslimat</span>
                <span>{offer.paymentDays} gün vade</span>
                <b>{offer.totalScore} puan</b>
              </div>
            ))}
          </div>
        ) : null}
        {excludedOffers.length ? (
          <div className="excluded-offers">
            <div className="compact-block-title">
              <strong>Değerlendirme dışı</strong>
              <span>{excludedOffers.length} teklif</span>
            </div>
            {excludedOffers.map((offer) => (
              <div key={offer.id}>
                <strong>{offer.supplier}</strong>
                <span>{offer.exclusionReasons.join(" ")}</span>
              </div>
            ))}
          </div>
        ) : null}
        <p className="comparison-footnote">{evaluation.disclaimer}</p>
      </section>
    ) : null}
  </>);
}
